/* forbo-wic-core.js - DEV 2026-10-17, unpublished theme only.
   Part 1 of 2. Config, cart I/O and the questionnaire. forbo-wic-ui.js adds the
   painting, dialog and tabs and must load AFTER this file (both are deferred,
   so document order is execution order).

   Split into two files only because the Admin API caps a GraphQL document at
   16,384 characters, which a single ~20KB asset cannot be written through. On
   promotion the two can be concatenated into one asset if preferred.

   Adapted from assets/wicanders-samples.js. DIFFERENT, all required by Forbo:
   - TWELVE products, not one. data-lines carries every line id, so a cart item
     is recognised as a sample by id lookup instead of one equality test.
   - Required fields and a checkout gate. Wicanders has neither.
   - Per-line question wording. The attribute KEYS stay fixed, so order data
     keeps the shape it has today.
   THE SAME, deliberately: state is the Shopify cart, no second cart is kept,
   every write is serialised through one promise chain, and cart lines are
   changed by line KEY, never by index.
*/
(function () {
  var root = document.querySelector('[data-wic-samples][data-forbo]');
  if (!root) return;

  var W = (window.ForboWic = {});
  W.root = root;
  W.NL = String.fromCharCode(10);
  W.cart = null;

  var LINES = [];
  try { LINES = JSON.parse(root.getAttribute('data-lines') || '[]'); } catch (e) { LINES = []; }
  W.LINE_NAME = {};
  W.IS_LINE = {};
  LINES.forEach(function (l) {
    W.IS_LINE[String(l.id)] = true;
    W.LINE_NAME[String(l.id)] = l.label;
  });

  W.MAX = parseInt(root.getAttribute('data-max-per-sample') || '0', 10) || 0;
  W.GATE_MSG = root.getAttribute('data-gate-message') || 'Please complete the required project information.';
  W.CART_URL = root.getAttribute('data-cart-url') || '/cart';

  var LS_KEY = 'forbo-sample-questions';
  var NOTE_OPEN = '[FORBO PROJECT INFO]';
  var NOTE_CLOSE = '[/FORBO PROJECT INFO]';
  var STATUS_ATTR = 'Forbo project - questionnaire status';

  W.q = function (s, c) { return (c || root).querySelector(s); };
  W.qa = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };

  W.fields = W.qa('[data-wic-field]');
  W.statusEls = W.qa('[data-wic-status]');
  W.dlg = W.q('[data-wic-dialog]');
  W.live = W.q('[data-wic-live]');
  W.bar = W.q('[data-wic-bar]');
  W.gateEl = W.q('[data-wic-gate]');
  W.checkoutEl = W.q('[data-wic-checkout]');
  W.quizTitleEl = W.q('[data-wic-quiz-title]');
  W.savedEl = W.q('[data-wic-saved]');

  W.money = function (cents) { return '$' + ((Number(cents) || 0) / 100).toFixed(2); };
  W.say = function (msg) { if (W.live) W.live.textContent = msg; };
  W.note = function (msg) {
    var el = W.q('[data-wic-dlg-msg]');
    if (el) el.textContent = msg || '';
  };

  var chain = Promise.resolve();
  W.queue = function (fn) {
    chain = chain.then(function () { return fn(); }, function () { return fn(); });
    return chain;
  };
  W.post = function (url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  };
  W.getCart = function () {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  };

  /* ---- cart partition: a sample is an item from ANY of the twelve lines ---- */
  W.sampleLines = function () {
    if (!W.cart || !W.cart.items) return [];
    return W.cart.items.filter(function (i) { return W.IS_LINE[String(i.product_id)] === true; });
  };
  W.otherCount = function () {
    if (!W.cart || !W.cart.items) return 0;
    return W.cart.items
      .filter(function (i) { return W.IS_LINE[String(i.product_id)] !== true; })
      .reduce(function (a, i) { return a + i.quantity; }, 0);
  };
  W.qtyOf = function (variantId) {
    var t = 0;
    W.sampleLines().forEach(function (i) { if (String(i.variant_id) === String(variantId)) t += i.quantity; });
    return t;
  };
  W.lineFor = function (variantId) {
    return W.sampleLines().filter(function (i) { return String(i.variant_id) === String(variantId); })[0] || null;
  };

  /* ---------------------------- questionnaire ---------------------------- */
  W.readFields = function () {
    return W.fields.map(function (f) {
      var ta = f.querySelector('textarea');
      return {
        n: f.getAttribute('data-n'),
        attr: f.getAttribute('data-attr'),
        label: f.getAttribute('data-label') || '',
        required: f.getAttribute('data-required') === '1',
        value: ta ? String(ta.value || '').trim() : '',
        el: f,
        ta: ta
      };
    });
  };
  W.missingRequired = function () {
    return W.readFields().filter(function (f) { return f.required && !f.value; });
  };
  W.anyAnswered = function () {
    return W.readFields().some(function (f) { return !!f.value; });
  };
  function saveLocal() {
    try {
      var o = {};
      W.readFields().forEach(function (f) { o[f.n] = f.value; });
      localStorage.setItem(LS_KEY, JSON.stringify(o));
    } catch (e) {}
  }
  function loadLocal() {
    try {
      var o = JSON.parse(localStorage.getItem(LS_KEY) || '{}');
      W.readFields().forEach(function (f) { if (!f.value && o[f.n] && f.ta) f.ta.value = o[f.n]; });
    } catch (e) {}
  }

  /* The note records each answer under the fixed NOTE_LABELS below, while the
     on-screen question wording stays per line; the attribute keys stay fixed. Any earlier
     block is spliced out first; the shopper's own note text is preserved. */
  function stripBlock(existing) {
    var body = String(existing || '');
    var a = body.indexOf(NOTE_OPEN);
    if (a !== -1) {
      var b = body.indexOf(NOTE_CLOSE, a);
      body = b !== -1 ? body.slice(0, a) + body.slice(b + NOTE_CLOSE.length) : body.slice(0, a);
    }
    while (body.charAt(0) === ' ' || body.charAt(0) === W.NL) body = body.slice(1);
    while (body.slice(-1) === ' ' || body.slice(-1) === W.NL) body = body.slice(0, -1);
    return body;
  }
  /* Fixed, collection-neutral labels for the order note (FORBO-BATCH-1, N3).
     The on-screen wording changes with the tab - Bulletin Board asks about
     on-site delivery - so recording the label last shown put wall-board
     wording on Marmoleum orders (#9920). Staff read the note, so it now
     carries one wording whatever tab was open; the screen is unchanged. */
  var NOTE_RULE = '----------------------------';
  var NOTE_LABELS = {
    '1': 'Project size (square feet or room dimensions)',
    '2': 'Project timeline / when the material is needed',
    '3': 'Additional project information'
  };
  W.buildNote = function (existing) {
    var body = stripBlock(existing);

    var fs = W.readFields().filter(function (f) { return !!f.value; });
    if (!fs.length) return body;
    var lines = [NOTE_OPEN];
    fs.forEach(function (f) {
      lines.push('Q' + f.n + ': ' + (NOTE_LABELS[f.n] || f.label));
      lines.push('A' + f.n + ': ' + f.value);
      /* One dash line after each answer: the quote job's parser
         (email-tracker parse_qa) splits Q/A pairs on it. Without it every
         answer after Q1 was glued onto A1 and the square feet never parsed. */
      lines.push(NOTE_RULE);
    });
    lines.push(NOTE_CLOSE);
    var block = lines.join(W.NL);
    return body ? body + W.NL + W.NL + block : block;
  };
  W.buildAttributes = function () {
    var attrs = {};
    W.readFields().forEach(function (f) { attrs[f.attr] = f.value; });
    attrs[STATUS_ATTR] = W.missingRequired().length ? 'incomplete' : 'complete';
    return attrs;
  };

  /* ------------------- project info belongs to the SAMPLES -------------------
     The cart may carry the Forbo answers only while a Forbo sample line is
     actually in it. Without that condition the answers restored from
     localStorage were re-stamped onto an EMPTY cart on the first tab paint
     (forbo-wic-ui.js applyWording -> pushQuestionnaire), so a shopper who
     answered the questions, emptied the cart and then bought something
     unrelated carried a [FORBO PROJECT INFO] note and three
     "Forbo project - ..." attributes onto that order.

     Two halves, and both are needed:
       - nothing is WRITTEN while no sample line exists, and
       - anything already written is CLEARED as soon as the last sample goes,
     because the guard alone would leave an existing note sitting in the cart.
     Writing the answers is therefore driven by the sample lines, not by the
     textareas; the textareas keep their own localStorage mirror either way, so
     nothing a shopper typed is lost - it simply does not reach the order until
     there is an order for it to describe. */
  function forboAttrKeys() {
    var keys = W.readFields().map(function (f) { return f.attr; });
    keys.push(STATUS_ATTR);
    return keys;
  }
  function blankAttributes() {
    var attrs = {};
    forboAttrKeys().forEach(function (k) { if (k) attrs[k] = ''; });
    return attrs;
  }
  /* Is there Forbo data in the cart right now that no sample justifies? */
  function staleInCart() {
    if (!W.cart) return false;
    if (String(W.cart.note || '').indexOf(NOTE_OPEN) !== -1) return true;
    var a = W.cart.attributes || {};
    return forboAttrKeys().some(function (k) { return k && a[k]; });
  }
  /* Unqueued: callers below are already inside the one serialised chain. */
  function reapCore() {
    if ((W.sampleLines() || []).length) return Promise.resolve(W.cart);
    if (!staleInCart()) return Promise.resolve(W.cart);
    return W.post('/cart/update.js', {
      attributes: blankAttributes(),
      note: stripBlock(W.cart && W.cart.note)
    }).then(function (c) {
      W.cart = c;
      if (W.paintStatus) W.paintStatus();
      if (W.paint) W.paint();
      return c;
    });
  }
  W.reapProjectInfo = function () { return W.queue(reapCore); };

  var pushTimer = null;
  W.pushQuestionnaire = function () {
    saveLocal();
    if (W.paintStatus) W.paintStatus();
    if (pushTimer) clearTimeout(pushTimer);
    pushTimer = setTimeout(function () {
      W.queue(function () {
        if (W.savedEl) W.savedEl.hidden = !W.anyAnswered();
        /* No sample in the cart: write nothing, and clear anything stale. */
        if (!(W.sampleLines() || []).length) return reapCore();
        return W.post('/cart/update.js', {
          attributes: W.buildAttributes(),
          note: W.buildNote(W.cart && W.cart.note)
        }).then(function (c) {
          W.cart = c;
          if (W.savedEl) W.savedEl.hidden = !W.anyAnswered();
          if (W.paint) W.paint();
        });
      });
    }, 600);
  };

  /* Server attributes outrank localStorage: the cart is the source of truth. */
  W.hydrateFromCart = function () {
    if (!W.cart) return;
    var a = W.cart.attributes || {};
    var got = false;
    W.readFields().forEach(function (f) {
      var v = a[f.attr];
      if (v && f.ta) { f.ta.value = v; got = true; }
    });
    if (!got) loadLocal();
    if (W.savedEl) W.savedEl.hidden = !W.anyAnswered();
    /* The samples can also be removed from the theme's own cart drawer, where
       this script is not running. Catch that on the next visit to any Forbo
       sample page: no sample line, but project info in the cart -> clear it. */
    W.reapProjectInfo();
  };

  /* ------------------------------ cart writes ------------------------------ */
  W.syncThemeBadges = function () {
    if (!W.cart) return;
    var n = W.cart.item_count || 0;
    ['#fcCount', '.float_count', '.cart-count', '[data-cart-count]'].forEach(function (s) {
      document.querySelectorAll(s).forEach(function (el) { el.textContent = n; });
    });
    document.querySelectorAll('#fcTotal').forEach(function (el) { el.textContent = W.money(W.cart.total_price); });
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: W.cart } }));
    try {
      if (window.theme && window.theme.cart && window.theme.cart.updateCart) window.theme.cart.updateCart();
    } catch (e) {}
  };
  W.addSample = function (variantId, qty) {
    return W.queue(function () {
      return W.post('/cart/add.js', {
        items: [{ id: Number(variantId), quantity: qty, properties: { _forbo_sample: '1' } }]
      }).then(function (added) {
        /* The note goes on HERE as well as in pushQuestionnaire. Until this
           moment there was no sample line, so the guard above refused to write
           - answers typed before the first sample would otherwise never reach
           the order. /cart/add.js does not touch the note, so `added.note` is
           the current one to splice. */
        return W.post('/cart/update.js', {
          attributes: W.buildAttributes(),
          note: W.buildNote(added && added.note)
        });
      }).then(function (c) {
        W.cart = c;
        if (W.paint) W.paint();
        W.syncThemeBadges();
      });
    });
  };
  W.setLine = function (key, qty) {
    return W.queue(function () {
      return W.post('/cart/change.js', { id: key, quantity: qty }).then(function (c) {
        W.cart = c;
        if (W.paint) W.paint();
        W.syncThemeBadges();
        /* Removing the LAST sample is what strands the project info, so
           reconcile immediately rather than waiting for a questionnaire edit
           that may never come. No-ops while any sample line remains. */
        return reapCore();
      }).then(function () {
        if (W.paint) W.paint();
        W.syncThemeBadges();
      });
    });
  };
})();